export default "__VITE_ASSET__DwJlKLvj__"